'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _adRenderer = require('@spp/ad-renderer');

var _keywordsModifiers = require('./config/keywords-modifiers');

var _keywordsModifiers2 = _interopRequireDefault(_keywordsModifiers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global window, HAS_ADS_PLUGIN, ADS_PLUGIN */
var identity = function identity(v) {
    return v;
};
var emptyObj = function emptyObj() {
    return {};
};
var plugin = (0, _extends3.default)({
    prepareTag: identity,
    addKeywordsToTag: emptyObj,
    preparePageOptions: identity,
    nativeRenderer: undefined
}, HAS_ADS_PLUGIN ? require(ADS_PLUGIN) // eslint-disable-line
: {});
var keywords = _keywordsModifiers2.default.concat(plugin.addKeywordsToTag);
var appnexusOptions = {
    prepareTag: function prepareTag(tag, options) {
        return keywords.reduce(function (preparedTag, modifier) {
            var newKeywords = modifier(preparedTag, options);
            if (newKeywords && (typeof newKeywords === 'undefined' ? 'undefined' : (0, _typeof3.default)(newKeywords)) === 'object') {
                (0, _assign2.default)(preparedTag.keywords, newKeywords);
            }
            return preparedTag;
        }, plugin.prepareTag(tag, options));
    },
    preparePageOptions: plugin.preparePageOptions
};

var renderer = (0, _adRenderer.rendererFactory)(appnexusOptions, plugin.nativeRenderer);

(0, _adRenderer.preload)(renderer);
window.adRenderer = renderer;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/roc-plugin-ads-appnexus/lib/renderer/index.js
 ** module id = 0
 ** module chunks = 1
 **/